import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { findCountryByCode, findStateByCode } from 'common/utils';

export const useGetUserLocation = () => {
  const { t: translationCountry } = useTranslation('translationCountries');
  const { t: translationState } = useTranslation('translationStates');

  return useCallback(
    ({ city, country, state }: { city?: string; country?: string; state?: string }) => {
      const stateFull = translationState(findStateByCode(state)?.translationKey ?? '');
      const countryFull = translationCountry(findCountryByCode(country)?.translationKey ?? '');

      return country === 'US'
        ? [city, stateFull].filter(Boolean).join(', ')
        : [city, countryFull].filter(Boolean).join(', ');
    },
    [translationCountry, translationState],
  );
};
